import get from 'get-value';
import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const aseExportInternalTickets = (state = {
    isLoadingExport: false,
    exportRecord: {},
    correlationId: null,
}, action) => {
    switch (action.type) {
        case aseWebsocketCommands.ASE_EXPORT_INTERNAL_GET: {
            return Object.assign({}, state, {isLoadingExport: true});
        }
        case aseWebsocketCommands.ASE_EXPORT_INTERNAL_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            const exportRecord = get(action, 'payload.exportRecord', {default: {}});
            return Object.assign({}, state, {
                isLoadingExport: false,
                exportRecord,
                correlationId,
            });
        }
        case aseWebsocketCommands.ASE_EXPORT_INTERNAL_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoadingExport: false});
        }
        case aseWebsocketCommands.ASE_EXPORT_INTERNAL_CREATE: {
            const exportRecord = {
                created: new Date(),
                status: 'NEW'
            };
            return Object.assign({}, state, {exportRecord});
        }
        case aseWebsocketCommands.ASE_EXPORT_INTERNAL_STATUS:
        case aseWebsocketCommands.ASE_EXPORT_INTERNAL_ERROR: {
            const {correlationId, exportRecord} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {exportRecord, correlationId});
        }
        default:
            return state;
    }
};
